export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/homeHeroMobile-4346ace2cc4dc7383ae4ab37749eaf8b.svg";